<template>
    <div class="agreement-wrap">
      <a-modal v-model:open="showModal" :title="state.detail?.title" width="1000px" :maskClosable="false" :footer="null" @cancel="hideModal" z-index="1100">
        <div v-html="state.detail?.content"></div>
      </a-modal>
    </div>
</template>

<script setup>
import {onMounted, reactive, toRefs} from "vue";
import {getRequest} from "@/assets/js/common";

const state = reactive({
  detail:'',
  agree:false,
});
const props = defineProps({
  showModal: {
    type: Boolean,
    default: false,
  },
  type: {
    type: Number,
    default: 0,
  },
});
const {type,showModal} = toRefs(props);
const emit = defineEmits(['agree','showModal']);

const getAgreement = () => {
  getRequest('/agreement',{type:type.value})
      .then(res => {
        if(res.code){
          state.detail = res.data[0];
        }
      })
      .catch(error => {
      }).finally(() => {
  });
}
const handleOk = () => {
  state.agree = true;
  emit('update:agree', {agree:state.agree});
  hideModal();
}
const hideModal = () => {
  emit('update:showModal', false);
}
onMounted(()=>{
  getAgreement();
})
</script>

<style scoped>
</style>